
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke145aRequest, Sgke145aResponse, Sgke145aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke145aService {

  /**
   * コンストラクタ
   * @param {Sgke145aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke145aService
   */
  constructor(
    public service: Sgke145aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE145A_手数料報告削除API呼び出し
   * @param {Sgke145aRequest} request 
   * @returns {Observable<Sgke145aResponse>}
   * @memberof UsedSgke145aService
   */
  public doSgke145a(request: Sgke145aRequest): Observable<Sgke145aResponse> {
    return this.service.sgke145aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE145A');
          return throwError(err.message);
        })
      );
  }

}
